import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/logo/romas.png'


const _hoisted_1 = { class: "simple-layout" }
const _hoisted_2 = {
  key: 0,
  class: "simple-header"
}
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "simple-content" }
const _hoisted_7 = { class: "container-fluid" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';

// Layout simple sans menu, sidebar ou footer
// Utilisé pour les pages qui ont besoin d'être affichées en plein écran

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleView',
  setup(__props) {

const showHeader = ref(true); // Peut être passé via meta route si besoin
const router = useRouter();

const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showHeader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "ROMAS",
                      style: {"max-height":"50px"}
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("div", { class: "header-actions" }, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: goBack
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1),
                  _createTextVNode(" Retour ")
                ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})